/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, December 8th 2023, 4:35:33 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ADMIN_PORTAL_DEPLOYMENT_MODE } from "config";

interface SaaSOnlyWrapperProps {
  children: React.ReactNode;
}

export const SaaSOnlyWrapper = ({ children }: SaaSOnlyWrapperProps) => {
  if (ADMIN_PORTAL_DEPLOYMENT_MODE === "SAAS") {
    return <>{children}</>;
  }
  return null;
};
